import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useNavigate } from "react-router-dom";

function Overview() {
  const name = localStorage.getItem("name");
  const role = localStorage.getItem("role");
  const email = localStorage.getItem("email");
  const navigate = useNavigate();
  return (
    <DashboardLayout>
      <DashboardNavbar hidebreadcrumbTitle />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <MDTypography variant="h6" color="white">
                    My Profile
                  </MDTypography>
                  <MDBox className="ticket_btnsHeaderCont">
                    <MDButton onClick={() => navigate("/profile/editpassword")} variant="outlined" color="white">
                      Change Password
                    </MDButton>
                  </MDBox>
                </Grid>
              </MDBox>
              <MDBox pt={3} px={2}>
                <MDBox mb={3}>
                  <MDTypography variant="outline">Name: {name}</MDTypography>

                </MDBox>
                <MDBox mb={3}>
                  <MDTypography variant="outline">Role: {role}</MDTypography>

                </MDBox>
                <MDBox mb={5}>
                  <MDTypography variant="outline">Email: {email}</MDTypography>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Overview;
